<template>
  <!-- 职务信息 -->
  <div class="person-info">
    <h3>
      <i></i>
      <span>职务信息</span>
      <div class="edit" @click="editInfo" v-if="!onEdit && hasFinished"><img src="../../assets/edit_icon.png"> 编辑</div>
    </h3>
    <div class="person-box">
      <section>
        <label class="tit">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
        <div class="con">
          <el-select v-model="workTitles" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getworkTitle">
            <el-option v-for="(job, key) in dutyInfo.dicWorkTitles" :key="key" :label="job" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{workTitleName}}</div>
        </div>
        <span class="error" v-if="jobErr">请选择职称</span>
      </section>
      <section>
        <label class="tit">行政职务：</label>
        <div class="con">
          <el-select v-model="administrativeDuties" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getDuties">
            <el-option v-for="(duties, key) in dutyInfo.dicAdminDutys" :key="key" :label="duties" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{administrativeDutiesName}}</div>
        </div>
        <span class="error" v-if="dutiesErr">请选择行政职务</span>
      </section>
      <section class="busniss-sec">
        <label class="tit">业务职务：</label>
        <div class="con">
          <el-checkbox label="0" v-model="isNullBusniss" @change="nullBusnissChecked" v-if="!hasFinished || onEdit">无</el-checkbox>
          <el-checkbox-group v-model="businessPosition" v-if="!hasFinished || onEdit" @change="getBusiness">
            <el-checkbox v-for="(business, key) in dutyInfo.dicVocDutys" :key="key" :label="key" v-if="key != '0'">{{business}}</el-checkbox>
          </el-checkbox-group>
          <div class="txt" v-if="!onEdit && hasFinished">{{businessPositionName}}</div>
        </div>
        <span class="error" v-if="businessErr">请选择业务职务</span>
      </section>
      <section>
        <label class="tit">编制情况：</label>
        <div class="con">
          <el-select v-model="establishment" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getEstablishment">
            <el-option v-for="(establishment, key) in dutyInfo.dicFootings" :key="key" :label="establishment" :value="key"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{establishmentName}}</div>
        </div>
        <span class="error" v-if="estabErr">请选择编制情况</span>
      </section>
      <section class="special-sec">
        <label class="tit">是否特级教师：</label>
        <div class="con">
          <el-radio-group v-model="isSpecial" v-if="!hasFinished || onEdit" @change="getSpecial">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
          <div class="txt" v-if="!onEdit && hasFinished">{{isSpecialName}}</div>
        </div>
        <span class="error" v-if="specialErr">请选择是否特技教师</span>
      </section>
      <section class="btn" v-if="!hasFinished || onEdit">
        <label class="tit">&nbsp;</label>
        <div class="con">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
export default {
  props: ['dutyInfo'],
  data () {
    return {
      hasFinished: this.dutyInfo.finishStatus, // 是否已经完成编辑
      workTitle: '', // 职称key
      workTitles: '',
      workTitleName: this.dutyInfo.workTitleName,
      adminDuty: '', // 行政职务key
      administrativeDuties: '',
      administrativeDutiesName: this.dutyInfo.adminDutyName,
      businessPosition: [],
      businessPositionName: '',
      establishment: '',
      footing: '', // 编制key
      establishmentName: this.dutyInfo.footingName,
      isSpecial: '',
      isSpecialName: this.dutyInfo.specialGrade ? '是' : '否',
      // 表单数据
      jobErr: false,
      dutiesErr: false,
      businessErr: false,
      estabErr: false,
      special: '',
      specialErr: false,
      isNullBusniss: false,
      // 编辑
      onEdit: false
    }
  },
  mounted () {
    // 未提交信息
    let localDutyInfo = window.sessionStorage.getItem('localDutyInfo')
    if (localDutyInfo) {
      let info = JSON.parse(localDutyInfo)
      this.hasFinished = info.finishStatus
      this.workTitleName = info.workTitleName
      this.workTitle = info.workTitle
      this.adminDuty = info.adminDuty
      this.administrativeDutiesName = info.administrativeDutiesName
      this.businessPositionName = info.businessPositionName
      this.footing = info.footing
      this.establishmentName = info.establishmentName
      this.isSpecialName = info.isSpecialName
      this.special = info.isSpecialName === '是' ? true : false
    } else if (this.dutyInfo.vocationalDutysNames.length > 0) {
      this.workTitle = this.dutyInfo.workTitle
      this.workTitles = this.dutyInfo.workTitleName
      this.workTitleName = this.dutyInfo.workTitleName
      this.adminDuty = this.dutyInfo.adminDuty
      this.administrativeDuties = this.dutyInfo.adminDutyName
      this.administrativeDutiesName = this.dutyInfo.adminDutyName
      this.businessPositionName = this.arrToStr(this.dutyInfo.vocationalDutysNames)
      this.footing = this.dutyInfo.footing
      this.establishmentName = this.dutyInfo.footingName
      this.isSpecialName = this.dutyInfo.specialGrade ? '是' : '否'
      this.special = this.dutyInfo.specialGrade
    }
    this.userId = window.sessionStorage.getItem('userId')
  },
  methods: {
    // 职称
    getworkTitle (val) {
      this.jobErr = false
      // console.log(val)
      this.workTitle = Number(val)
      for (let i in this.dutyInfo.dicWorkTitles) {
        if (val === i) {
          this.workTitleName = this.dutyInfo.dicWorkTitles[i]
        }
      }
    },
    // 行政职务
    getDuties (val) {
      this.dutiesErr = false
      this.adminDuty = Number(val)
      for (let i in this.dutyInfo.dicAdminDutys) {
        if (val === i) {
          this.administrativeDutiesName = this.dutyInfo.dicAdminDutys[i]
        }
      }
    },
    // 业务职务
    nullBusnissChecked (val) {
      if (val) {
        this.businessPosition = ['0']
        this.businessPositionName = this.arrToStr(['无'])
        this.businessErr = false
        this.isNullBusniss = true
      } else {
        this.isNullBusniss = false
      }
    },

    getBusiness (val) {
      let index = val.indexOf('0')
      if (index > -1) {
        val.splice(index, 1)
      }
      // 业务职务取值
      if (val.length > 0) {
        let businessName = []
        for (let i = 0; i < val.length; i++) {
          for (let j in this.dutyInfo.dicVocDutys) {
            if (val[i] === j) {
              businessName.push(this.dutyInfo.dicVocDutys[j])
            }
          }
        }
        this.businessPositionName = this.arrToStr(businessName)
      }
      this.businessErr = false
      this.isNullBusniss = false
    },
    // 编制情况
    getEstablishment (val) {
      this.estabErr = false
      this.footing = Number(val)
      for (let i in this.dutyInfo.dicFootings) {
        if (val === i) {
          this.establishmentName = this.dutyInfo.dicFootings[i]
        }
      }
    },
    // 是否特级教师
    getSpecial (val) {
      this.special = (val === '是') ? true : false
      this.isSpecialName = val
      this.specialErr = false
    },
    // 数组转字符串
    arrToStr (arr) {
      let newStr = ''
      if (arr.length > 0) {
        newStr = (arr.join('，')).replace(/\"/g, '')
        newStr = newStr.replace(/\'/g, '')
        return newStr
      }
    },
    // 数组元素字符转数字
    arrStrToNum (arr) {
      let newArr = []
      if (arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          newArr.push(Number(arr[i]))
        }
        return newArr
      }
    },
    onSubmit () {
      let _this = this
      if (_this.workTitles === '') {
        _this.jobErr = true
        return false
      }
      if (_this.administrativeDuties === '') {
        _this.dutiesErr = true
        return false
      }
      if (_this.businessPosition.length <= 0) {
        _this.businessErr = true
        return false
      }
      if (_this.establishment === '') {
        _this.estabErr = true
        return false
      }
      if (_this.special === '') {
        _this.specialErr = true
        return false
      }
      let dutyInfo = {
        userId: _this.userId,
        workTitle: parseInt(_this.workTitle),
        adminDuty: parseInt(_this.adminDuty),
        footing: parseInt(_this.footing),
        specialGrade: _this.special,
        vocationalDutys: _this.arrStrToNum(_this.businessPosition),
        finishStatus: false
      }
      api.post('SaveSZTeacherPersonalInfoRequest', {
        part: 5,
        dutyInfo: dutyInfo
      }, res => {
        // console.log(res)
        _this.$message({
          message: '职务信息保存成功',
          type: 'success'
        })
        // 本地数据存储
        let localDutyInfo = {
          finishStatus: true,
          workTitle: _this.workTitle,
          workTitleName: _this.workTitleName,
          adminDuty: _this.adminDuty,
          administrativeDutiesName: _this.administrativeDutiesName,
          establishmentName: _this.establishmentName,
          footing: _this.footing,
          businessPositionName: _this.businessPositionName,
          isSpecialName: _this.isSpecialName
        }
        window.sessionStorage.setItem('localDutyInfo', JSON.stringify(localDutyInfo))
        _this.hasFinished = true
        if (!_this.onEdit) {
          _this.$emit('hasFinish', 4)
        } else {
          _this.onEdit = false
        }
      })
    },
    // 编辑
    editInfo () {
      this.onEdit = true
      this.workTitles = this.workTitleName
      this.administrativeDuties = this.administrativeDutiesName
      this.establishment = this.establishmentName
      this.isSpecial = this.isSpecialName
      if (this.businessPositionName === '无') {
        this.isNullBusniss = true
      } else {
        this.businessPosition = this.getKeyArr((this.businessPositionName).split('，'), this.dutyInfo.dicVocDutys)
      }
    },
    // 根据value获取key
    getKeyArr (valueArr, valueObj) {
      let keyArr = []
      for (let i = 0; i < valueArr.length; i++) {
        for (let j in valueObj) {
          if (valueArr[i] === valueObj[j]) {
            keyArr.push(j)
          }
        }
      }
      return keyArr
    }
  }
}
</script>
<style scoped>
  .person-info h3 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
  }
  .person-info h3 i {
    width: 2px;
    height: 16px;
    background: #FE793A;
    margin-right: 10px;
  }

  .person-info h3 span {
    flex: 1;
  }

  .person-info h3 .edit {
    color: #FE793A;
    font-size: 12px;
    cursor: pointer;
  }

  .person-info h3 .edit img {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-bottom: 3px;
  }

  .person-box {
    margin-top: 24px;
  }
  .person-box section {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .person-box section .tit {
    width: 70px;
    font-size: 14px;
    color: #333;
  }
  .person-box section .txt {
    font-size: 14px;
  }

  .person-box section.special-sec .tit {
    width: 100px;
  }

  .person-box section .con {
    width: 230px;
    margin-left: 5px;
  }
  .person-box section .error {
    width: 345px;
    text-align: left;
    font-size: 12px;
    color: #ff0000;
  }
  .person-box section.busniss-sec .con {
    width: 430px;
  }
  .person-box section.busniss-sec .con .el-checkbox-group {
    display: inline;
  }
  .person-box section.busniss-sec .error {
    width: 160px;
  }
  .person-box section.busniss-sec .el-checkbox {
    margin-bottom: 10px;
  }
  .person-box section.btn {
    margin-top: 40px;
  }
  .w35 {
    width: 35.5%;
  }
</style>
